/**
 * @description: 根据文章等级做页面样式控制-配置文件
 * @param {*} Sgrade 文章等级，当前有S+、S、S-、A四类
 * @return {null}
 */
import {
    handleComment,
    renderMeComment,
    lazyLoadBLock,
    renderRightSideBar,
    renderAllSeeList,
    renderShareInteration
} from './handleDom'
import ad from "@/components/adver/article_ad" // todo另外九个广告
import { hideDom } from '@/utils/Utils'

var SgradeMap = ['A', 'S-', 'S', 'S+']
export default function (opts) {
    var Sgrade = opts.sGrade
    var ArtGrade = SgradeMap[Number(Sgrade)]
    console.log('Grade:', ArtGrade)

    renderShareInteration() // 左侧互动&分享
    handleComment() // 左侧评论区块处理
    renderMeComment() // 我来说两句
    if (ArtGrade === 'S+') {
        hideDom('.left-bottom-float') // 左下角广告
        hideDom('.left-bottom-float-fullScreenSleepContainer') // 全屏广告
        hideDom('.statement') // 平台声明
        hideDom('#groomRead') // 推荐阅读
        hideDom('#articleAllsee') // 大家都在看
        lazyLoadBLock(['commentList']) // 评论列表
    }
    if (ArtGrade === 'S') {
        hideDom('.left-bottom-float-fullScreenSleepContainer') // 全屏广告
        hideDom('.left-bottom-float') // 左下角广告
        hideDom('.statement') // 平台声明
        hideDom('#groomRead') // 推荐阅读
        hideDom('#articleAllsee') // 大家都在看
        lazyLoadBLock(['commentList']) // 评论列表
    }
    if (ArtGrade === 'S-') {
        renderRightSideBar()
        hideDom('.left-bottom-float-fullScreenSleepContainer') // 全屏广告
        hideDom('.left-bottom-float') // 左下角广告
        // 去广告
        opts.removeAd = true
        renderAllSeeList() // 大家都在看
        lazyLoadBLock(['commentList','groomRead']) // 推荐阅读，评论列表
    }
    if (ArtGrade === 'A') {
        renderRightSideBar()
        renderAllSeeList() // 大家都在看
        lazyLoadBLock(['groomRead','commentList']) // 推荐阅读,评论列表


        // 独立广告位
        ad.init({
            media_id: opts.media_id,
            news_id: opts.news_id,
            channel_id: opts.channel_id,
            categoryId: opts.categoryId,
            subid: opts.media_id,
            isBaidu: opts.isBaiDuAd,
            secureScore: opts.secureScore,
            showAd: true, // 当文章页等级为A（0）时，展示广告
            keywords: opts.keywords
        });
    }
}